export default "__VITE_PUBLIC_ASSET__fc48dfdf__"